import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.75 3.53a.76.76 0 0 1-.75.75H7.18a1.78 1.78 0 0 1-3.25 0H2a.75.75 0 0 1 0-1.5h1.93a1.78 1.78 0 0 1 3.25 0H14a.75.75 0 0 1 .75.75ZM14 12.1H7.18a1.79 1.79 0 0 0-3.25 0H2a.75.75 0 0 0 0 1.5h1.93a1.78 1.78 0 0 0 3.25 0H14a.75.75 0 0 0 0-1.5Zm0-4.64h-1.91a1.8 1.8 0 0 0-1.64-1.06 1.78 1.78 0 0 0-1.63 1.06H2A.75.75 0 0 0 2 9h6.84a1.77 1.77 0 0 0 1.61 1 1.8 1.8 0 0 0 1.62-1H14a.75.75 0 0 0 0-1.5Z';
const draw24px =
  'M21.78,19a.76.76,0,0,1-.75.75H10.48a2.31,2.31,0,0,1-4.37,0H3a.75.75,0,1,1,0-1.5H6.11a2.31,2.31,0,0,1,4.37,0H21A.76.76,0,0,1,21.78,19ZM21,4.17H10.48a2.32,2.32,0,0,0-4.37,0H3a.75.75,0,0,0,0,1.5H6.11a2.31,2.31,0,0,0,4.37,0H21a.75.75,0,0,0,0-1.5Zm0,7.06H17.87a2.31,2.31,0,0,0-4.37,0H3a.75.75,0,1,0,0,1.5H13.5a2.31,2.31,0,0,0,4.37,0H21a.75.75,0,0,0,0-1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const KnobIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'knob'),
) as IconWithRender;

KnobIcon.displayName = 'KnobIcon';
KnobIcon.propTypes = Icon.propTypes;
KnobIcon.renderIcon = (props) => <KnobIcon {...props} />;
export default KnobIcon;
